
import './Body.css';
import React from "react";
import aboutPageMessage from '../assets/images/aboutPageMessage.png'
import Footer from '../pages/Footer.js'

function About(props) {

    return (
        <div>
            <div className="">
                <img className="aboutBouquet" src={aboutPageMessage} alt="Feeling gratitude and not expressing it is like wrapping a present and not giving it. William Arthur Ward" />
                <p className="descriptionText"> E-florals was built for expressing gratitude. We love receiving flowers, and often the most meaningful aspect is the note or sentiment that accompanies them. Knowing that someone loves you, appreciates you, and wants you to succeed can make all the difference, and now more than ever, we need all of the positivity we can get.   </p>
                <p className="descriptionText">Using e-florals, you can send someone a free, digital bouquet designed and customized just for them, with a special note attached, in an unexpected, day-brightening way. As a bonus, few things are more calming than arranging flowers, and with e-florals, you can relax your mind while creating stunning bouquets for someone special in your life.</p>
            </div>
        <Footer/>
        </div>
    )
}

export default About;